export default __webpack_public_path__ + "static/media/magajahallifalls.b239d4ac.jpg";